import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeasonsComponent } from './seasons.component';
import {RouterModule, Routes} from '@angular/router';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {PageHeaderModule} from '../../core/page-header/page-header.module';
import {BreadcrumbsModule} from '../../core/breadcrumbs/breadcrumbs.module';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {
    MatButtonToggleModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatInputModule, MatListModule, MatTableModule,
    MatTabsModule
} from '@angular/material';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {EditDriverEntryModule} from '../events/event-detail/edit-driver-entry/edit-driver-entry.module';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule} from '@angular/forms';
import {TeamComponent} from '../team/team.component';
import {AngularCountdownTimerModule} from 'angular8-countdown-timer';
import { RaceSignupComponent } from './race-signup/race-signup.component';
import { SignupDialogComponent } from './race-signup/signup-dialog/signup-dialog.component';
import { UpcomingSessionsComponent } from './upcoming-sessions/upcoming-sessions.component';
import { MySessionsComponent } from './my-sessions/my-sessions.component';
import { StandingsComponent } from './standings/standings.component';
import {CdkTableModule} from '@angular/cdk/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import { RecentSessionsComponent } from './recent-sessions/recent-sessions.component';
import {RaceDetailModalComponent} from '../events/race-detail-modal/race-detail-modal.component';
import {EventsModule} from '../events/events.module';
import {seasonsRouting} from './seasons.routing';
import {ReportIncidentComponent} from '../users/report-incident/report-incident.component';
import {UsersModule} from '../users/users.module';
import {ReportIncidentModule} from '../users/report-incident/report-incident.module';
import { SeasonsDetailComponent } from './seasons-detail/seasons-detail.component';
import {PipesModule} from '../../pipes/pipes.module';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import { SeasonsArchiveComponent } from './seasons-archive/seasons-archive.component';
import { UpcomingSessionsNewComponent } from './upcoming-sessions-new/upcoming-sessions-new.component';
import {AdsenseModule} from 'ng2-adsense';
import { TeamSignupComponent } from './race-signup/team-signup/team-signup.component';
import {SortablejsModule} from 'ngx-sortablejs';
import {PagesModule} from '../pages.module';
import {LivetimingComponent} from '../seasonsv2/livetiming/livetiming.component';
import {AdServiceModule} from '../ad-service/ad-service.module';


@NgModule({
  declarations: [SeasonsComponent, RaceSignupComponent, SignupDialogComponent, UpcomingSessionsComponent, MySessionsComponent, StandingsComponent, RecentSessionsComponent, SeasonsDetailComponent, SeasonsArchiveComponent, UpcomingSessionsNewComponent, TeamSignupComponent],
    imports: [
        seasonsRouting,
        EventsModule,
        CommonModule,
        FlexModule,
        CommonModule,
        PageHeaderModule,
        BreadcrumbsModule,
        FlexLayoutModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatTabsModule,
        EditDriverEntryModule,
        MatGridListModule,
        MatMenuModule,
        MatDividerModule,
        FormsModule,
        MatCardModule,
        MatExpansionModule,
        MatDialogModule,
        MatTableModule,
        AngularCountdownTimerModule,
        MatTableModule,
        CdkTableModule,
        MatPaginatorModule,
        ReportIncidentModule,
        MatButtonToggleModule,
        PipesModule,
        NgxMatSelectSearchModule,
        MatListModule,
        AdsenseModule,
        SortablejsModule,
        PagesModule,
        AdServiceModule
    ],
  exports: [
    RaceSignupComponent,
    UpcomingSessionsComponent
  ],
  entryComponents: [SignupDialogComponent, RaceDetailModalComponent, ReportIncidentComponent, TeamSignupComponent]
})
export class SeasonsModule { }
